import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem, Image } from "react-bootstrap";
import "./App.css";
import Routes from "./Routes";
import { LinkContainer } from "react-router-bootstrap";
import FullStory from 'react-fullstory';
import homeIcon from './home-52.svg';
import pencilIcon from './pencil.svg';


class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      basicAuth: "",
      userId: "",
      summary: "",
      summaryId: ""
    };
  }

  // =============
  // Basically what to do on startup
  // =============

  componentDidMount() {
    try {
      if (localStorage.getItem('cache_isAuthenticated') === 'true') {
        this.setState({ basicAuth: localStorage.getItem('cache_basicAuth') });
        this.userHasAuthenticated(true);
      }
    }
    catch(e) {
      alert(e);
    }
  }



  // =============
  // Functions
  // =============

  setUserAuth = authString => {
    this.setState({ basicAuth: authString });
    // Local browser storage to hold the login
    localStorage.setItem('cache_basicAuth', authString );
  }

  setUserId = currentUserId => {
    this.setState({ userId: currentUserId });
    // Local browser storage to hold the login
    localStorage.setItem('cache_userId', currentUserId );
  }

  setSummary = summary => {
    //id
    this.setState({ summaryId: summary.id });
    localStorage.setItem('cache_summaryId', summary.id );

    // summary
    this.setState({ summary: summary.summary });
    localStorage.setItem('cache_summary', summary.summary );

    // outline
    this.setState({ outline: summary.outline });
    localStorage.setItem('cache_outline', summary.outline );

    // topics
    this.setState({ summaryTopics: summary.topics });
    localStorage.setItem('cache_summaryTopics', summary.topics );

    // title
    this.setState({ summaryTitle: summary.title });
    localStorage.setItem('cache_summaryTitle', summary.title );

    // Original Word Count
    this.setState({ originalWordCount: summary.original_text_word_count });
    localStorage.setItem('cache_summaryOriginalWordCount', summary.original_text_word_count );

    // Summary Word Count
    this.setState({ summaryWordCount: summary.summary_word_count });
    localStorage.setItem('cache_summaryWordCount', summary.summary_word_count );

    // Rating
    this.setState({ summaryRating: summary.rating });
    localStorage.setItem('cache_summaryRating', summary.rating );
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
    localStorage.setItem('cache_isAuthenticated', true );
  }

  handleLogout = event => {
    // Clear the state and cache
    this.userHasAuthenticated(false);
    this.setUserAuth("");
    localStorage.setItem('cache_isAuthenticated', false );
    localStorage.removeItem('cache_basicAuth' );
    localStorage.removeItem('cache_userId' );
    localStorage.removeItem('cache_originalText' );
    localStorage.removeItem('cache_url' );
    // Clear summary cache
    localStorage.removeItem('cache_summary');
    localStorage.removeItem('cache_summaryTopics');
    localStorage.removeItem('cache_summaryTitle');
    // clear summary home page list cache
    localStorage.removeItem('cache_summariesList')
    // Send user to login screen
    this.props.history.push("/login");
  }


  render() {
    // Passing functions down to other components like login
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      setUserAuth: this.setUserAuth,
      setUserId: this.setUserId,
      handleLogout: this.handleLogout,
      basicAuth: this.state.basicAuth,
      userId: this.state.userId,
      setSummary: this.setSummary
    };


  return (
    <div className="App container">

      <div className="fullstory_tracking">
          <FullStory org="GG6TS" />
      </div>

    <div id="tile">
      <h4> B E T A </h4>
    </div>

      <h1> Autonote <img src={pencilIcon} /> </h1>

      <Navbar fluid>
        <Navbar.Header>

        <Navbar.Brand>
          <Link to="/">Home</Link>
        </Navbar.Brand>

        <Navbar.Brand>
          <Link to="/summary/new"> New </Link>
        </Navbar.Brand>


            {this.state.isAuthenticated
   // if statement example
            ? <Navbar.Brand>
                <NavItem onClick={this.handleLogout}>
                  Logout
                </NavItem>
              </Navbar.Brand>
            : <span>
                <Navbar.Brand>
                    <Link to="/signup"> Sign up </Link>
                </Navbar.Brand>
                <Navbar.Brand>
                    <Link to="/login"> Login </Link>
                </Navbar.Brand>
              </span>
          }
      </Navbar.Header>
      </Navbar>
      <Routes childProps={childProps} />
    </div>
  );
}
}

export default withRouter(App);
